module.exports = __webpack_public_path__ + "media/images/dummy_item3-09a784f446156d59491469291c4aebfa.jpeg";